import { create } from 'zustand';
import type { AssistantView, AssistantMode } from '../interfaces/IAssistantContext';
import { ROOT_VIEW } from '../interfaces/IAssistantContext';

interface AssistantNavigationState {
  navigationStack: AssistantView[];
  activeMode: AssistantMode;

  pushView: (view: AssistantView) => void;
  popView: () => void;
  resetNavigation: () => void;
  setMode: (mode: AssistantMode) => void;

  getCurrentView: () => AssistantView;
}

export const useAssistantNavigationStore = create<AssistantNavigationState>((set, get) => ({
  navigationStack: [ROOT_VIEW],
  activeMode: { type: 'normal' },

  pushView: (view) =>
    set((state) => ({
      navigationStack: [...state.navigationStack, { ...view, parentId: state.navigationStack[state.navigationStack.length - 1]?.id }],
    })),

  popView: () =>
    set((state) => {
      if (state.navigationStack.length <= 1) return state;
      return { navigationStack: state.navigationStack.slice(0, -1) };
    }),

  resetNavigation: () =>
    set({
      navigationStack: [ROOT_VIEW],
      activeMode: { type: 'normal' },
    }),

  setMode: (mode) => set({ activeMode: mode }),

  getCurrentView: () => {
    const stack = get().navigationStack;
    return stack[stack.length - 1] ?? ROOT_VIEW;
  },
}));
